module.exports = __webpack_public_path__ + "static/media/instrumentalist.8995e7c3.svg";